import {createSlice} from "@reduxjs/toolkit";

const pvSlice = createSlice({
    name: "pv",
    initialState: {
        vouchers: []
    },
    reducers: {
        addPaymentVoucher: (state, action) => {
            state.vouchers.push(action.payload);
        },

        clearVouchers: () => {

        }
    }
});

export const {addPaymentVoucher, clearVouchers} = pvSlice.actions;
export default pvSlice.reducer;